import React from 'react';
import MenuItem from './MenuItem';
import { MenuSectionValueType } from '../../types/lib/types';
import './MenuContainer.css';
import MenuCategory from './MenuCategory';

interface MenuCategoryProps {
    sectionName: string;
    menu: MenuSectionValueType;
    selectedLayers: string[] | undefined;
    setSelectedLayers: (value: string[] | undefined) => void;
}

const MenuContainer: React.FC<MenuCategoryProps> = ({ sectionName, menu, selectedLayers, setSelectedLayers }) => {

    return (
        <div key={sectionName} className='sidebar-item-container'>
            <div className='title-wrapper'>
                <p className='item-container-title'>{sectionName}</p>
            </div>
            <div className="menu">
                {Object.entries(menu.items).map(([key, item]) => (
                    item.type === 'category' ?
                        <MenuCategory
                            key={item.id}
                            id={item.id}
                            label={key}
                            menuItems={item.items}
                            selectedLayers={selectedLayers}
                            setSelectedLayers={setSelectedLayers}
                        />
                        :
                        <MenuItem
                            key={item.id}
                            id={item.id}
                            item={item}
                            label={key}
                            isAlert={'metadata' in item && item.metadata?.geometryType === 'Alert'}
                            selectedLayers={selectedLayers}
                            setSelectedLayers={setSelectedLayers}
                        />
                ))}
            </div>
        </div>
    );
};

export default MenuContainer;
